import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import SupportRequestPage from './SupportRequestPage';
import { push } from 'react-router-redux';
import { getSupportTypes, getUserRequestData, goFeedBackPage, supportChatUser } from 'src/actions/supportRequestAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { orderno, orderDisabled } from 'src/actions/supportAction';
import { saveLoadingState } from 'src/actions/landingPageAction';
import { rowClick } from 'src/actions/completeOrderAction';
// import { saveQueryType, saveMessages, saveAttachment, doSubmit } from 'src/actions/supportAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    supportRequest: state.supportRequest.supportRequestData,
    supportRequestTypes: state.supportRequest.supportRequestTypes,
    session: state.user.userDetails.s,
    apiUrl: state.environment.API_URL,
    username: state.user.userDetails.userName
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      dispatch(getUserRequestData);
      dispatch(getSupportTypes);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
    },
    goSupportPage: () => {
      dispatch(orderno(''));
      dispatch(orderDisabled(false));
      dispatch(push('/app/support'));
    },
    goSupportChat: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => {
      dispatch(supportChatUser(ticketno, date, supporttype, status, mtype, caseno));
    },
    onRowClick: (orderid: string, rowData: string) => {
      dispatch(rowClick(orderid, rowData));
    },
    saveLoading: (loading: boolean) => {
      dispatch(saveLoadingState(loading));
    },
    goToFeedback: (ticketno: string, date: string, supporttype: string, status: string, mtype: string, caseno: string) => {
      dispatch(goFeedBackPage(ticketno, date, supporttype, status, mtype, caseno));
    },
  };
};

const SupportRequestPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportRequestPage);

export default SupportRequestPageContainer;



// WEBPACK FOOTER //
// ./src/components/supportRequest/SupportRequestPageContainer.tsx